export const tag = 'vehicleMarketListTemplate';
export const load = async () => {
    const { VehicleMarketPlatformListComponent } = await import('./vehicle-market-list.component');
    return {
        component: VehicleMarketPlatformListComponent,
    };
};
